    <div class="dff-field-cell" [ngClass]="field.visible ? field.columnSpanClass : ''">
        @if (field.visible && templateState) {
            <span class="template-field-pill"
                [class.template-field-pill--edited]="templateState === 'edited'">
                {{ (templateState === 'edited' ? 'Edited' : 'From template') | translate }}
            </span>
        }
        @if (field.type === FormFieldType.Text && field.visible) {
            <mat-form-field
                appearance="outline"
                [class]="field.cssClass"
            >
                <mat-label class="field-label"
                    >{{ field.name | translate }}
                    @if (field.tooltip) {
                        <i
                            class="fa fa-info-circle"
                            aria-hidden="true"
                            [matTooltip]="field.tooltip"
                            matTooltipPosition="right"
                        ></i>
                    }
                </mat-label>
                <input
                    matInput
                    [(ngModel)]="entity[field.property]"
                    [required]="field.required"
                    [disabled]="field.readonly"
                    [class.cursor-not-allowed]="field.readonly"
                    (change)="field.onChange($event, field)"
                    (input)="emitValueChanged()"
                    [placeholder]="field.tooltip"
                />
                <mat-error
                    >{{ field.name | translate }}
                    {{ "is required" | translate }}</mat-error
                >
            </mat-form-field>
        }

        @if (field.type === FormFieldType.TextArea && field.visible) {
            <mat-form-field
                appearance="outline">
                <mat-label class="field-label"
                    >{{ field.name | translate }}
                    @if (field.tooltip) {
                        <i
                            class="fa fa-info-circle"
                            aria-hidden="true"
                            [matTooltip]="field.tooltip"
                            matTooltipPosition="right"
                        ></i>
                    }
                </mat-label>
                <textarea
                    matInput
                    [(ngModel)]="entity[field.property]"
                    [required]="field.required"
                    [placeholder]="field.tooltip"
                    [disabled]="field.readonly"
                    [class.cursor-not-allowed]="field.readonly"
                    (input)="emitValueChanged()"
                ></textarea>
                <mat-error
                    >{{ field.name | translate }}
                    {{ "is required" | translate }}</mat-error
                >
            </mat-form-field>
        }

        @if (
                (field.type === FormFieldType.SingleSelection ||
                    field.type === FormFieldType.MultipleSelection ||
                    field.type === FormFieldType.HierarchicalSelection) &&
                field.visible
        ) {
            <mat-form-field
                appearance="outline"
                [class]="field.cssClass"
            >
                <mat-label class="field-label"
                    >{{ field.name | translate }}
                    @if (field.tooltip) {
                        <i
                            class="fa fa-info-circle"
                            aria-hidden="true"
                            [matTooltip]="field.tooltip"
                            matTooltipPosition="right"
                        ></i>
                    }
                </mat-label>
                <mat-select
                    (selectionChange)="field.onChange($event, field); emitValueChanged()"
                    [(ngModel)]="entity[field.property]"
                    [required]="field.required"
                    [disabled]="$safeNavigationMigration(field?.readonly)"
                    [class.cursor-not-allowed]="field.readonly"
                    [multiple]="isMultiple"
                    [panelClass]="
                        field.type === FormFieldType.HierarchicalSelection
                            ? 'hierarchical-select-panel'
                            : field.optionTemplate ||
                                field.optionTemplateFields?.length
                              ? 'multiple-select-panel'
                              : ''
                    "
                    [placeholder]="field.tooltip"
                >
                    <mat-option>
                        <ngx-mat-select-search
                            [(ngModel)]="entity[field.searchProperty]"
                            placeholderLabel="{{ 'Search' | translate }}..."
                            (ngModelChange)="field.onSearchChange($event, field)"
                        >
                        </ngx-mat-select-search>
                    </mat-option>

                    @if (
                            field.type === FormFieldType.HierarchicalSelection &&
                            (
                                field.options
                                | filter
                                    : entity[field.searchProperty]
                                    : field.searchKeys
                            ).length === 0
                    ) {
                        <mat-option
                            disabled
                        >
                            {{ "No options found" | translate }}
                        </mat-option>
                    }

                    @if (field.type === FormFieldType.HierarchicalSelection) {
                        <ng-container
                            *ngTemplateOutlet="
                                renderTree;
                                context: {
                                    nodes:
                                        field.options
                                        | filter
                                            : entity[field.searchProperty]
                                            : field.searchKeys,
                                    level: 0,
                                }
                            "
                        ></ng-container>
                    }

                    @if (field.type !== FormFieldType.HierarchicalSelection) {
                        @if (field.groups && field.groups.length > 0) {
                            @for (group of field.groups; track $index) {
                                <mat-optgroup
                                    [label]="group.groupName"
                                >
                                    @for (option of group.items | filter : entity[field.searchProperty]; track trackById($index, option)) {
                                        <mat-option
                                            [value]="option.id"
                                        >
                                            {{ option.name | translate }}
                                        </mat-option>
                                    }
                                    @if ((group.items | filter : entity[field.searchProperty]).length === 0) {
                                        <mat-option
                                            disabled
                                        >
                                            {{ "No options found" | translate }}
                                        </mat-option>
                                    }
                                </mat-optgroup>
                            }
                        } @else {
                            @if (field.optionTemplate && !field.optionTemplateFields?.length && field.options.length) {
                                <mat-option
                                    disabled
                                    class="static-option-header"
                                >
                                    <div
                                        class="select-option header"
                                        [innerHTML]="
                                            field.optionTemplate(field.options[0], true)
                                                | safeHtml
                                        "
                                    ></div>
                                </mat-option>
                            }
                            @if (field.optionTemplateFields?.length && field.options.length) {
                                <mat-option
                                    disabled
                                    class="static-option-header"
                                >
                                    <app-option-row
                                        [option]="field.options[0]"
                                        [fields]="field.optionTemplateFields"
                                        [isHeader]="true"
                                        [labelMap]="field.optionTemplateLabelMap"
                                        [badgeFields]="field.optionTemplateBadgeFields"
                                    >
                                    </app-option-row>
                                </mat-option>
                            }

                            @for (option of field.options | filter : entity[field.searchProperty] : field.searchKeys; track trackById($index, option)) {
                                <mat-option
                                    [value]="option.id"
                                >
                                    @if (field.optionTemplate) {
                                        <div
                                            class="select-option"
                                            [innerHTML]="
                                                field.optionTemplate(option, false) | safeHtml
                                            "
                                        ></div>
                                    } @else {
                                        @if (field.optionTemplateFields?.length) {
                                            <app-option-row
                                                [option]="option"
                                                [fields]="field.optionTemplateFields"
                                                [isHeader]="false"
                                                [labelMap]="
                                                    field.optionTemplateLabelMap
                                                "
                                                [badgeFields]="
                                                    field.optionTemplateBadgeFields
                                                "
                                            >
                                            </app-option-row>
                                        } @else {
                                            {{ option.name | translate }}
                                        }
                                    }
                                </mat-option>
                            }

                            @if (
                                    (
                                        field.options
                                        | filter
                                            : entity[field.searchProperty]
                                            : field.searchKeys
                                    ).length === 0
                            ) {
                                <mat-option
                                    disabled
                                >
                                    {{ "No options found" | translate }}
                                </mat-option>
                            }
                        }
                    }

                    @if (field.selectionTemplate) {
                        <mat-select-trigger>
                            <span
                                [innerHTML]="field.selectionTemplate(field) | safeHtml"
                            ></span>
                        </mat-select-trigger>
                    }

                    <ng-template #renderTree let-nodes="nodes" let-level="level">
                        @for (node of nodes; track trackById($index, node)) {
                            <mat-option
                                [value]="node.id"
                                [ngClass]="'mat-level-' + level"
                            >
                                @for (i of [].constructor(level); track $index; let idx = $index) {
                                    <div
                                        class="pre-option-line"
                                        [ngClass]="'pre-option-level-' + idx"
                                    ></div>
                                }
                                {{ node.name }}
                            </mat-option>
                            @if (node.children && node.children.length > 0) {
                                <ng-container
                                    *ngTemplateOutlet="
                                        renderTree;
                                        context: {
                                            nodes: node.children,
                                            level: level + 1,
                                        }
                                    "
                                ></ng-container>
                            }
                        }
                    </ng-template>
                </mat-select>

                @if (
                        entity[field.property] !== null &&
                        entity[field.property] !== undefined &&
                        field.type === FormFieldType.SingleSelection &&
                        !field?.readonly
                ) {
                    <button
                        class="selection-close-btn"
                        mat-icon-button
                        matSuffix
                        tabindex="-1"
                        (click)="clearSelect(field); $event.stopPropagation()"
                        aria-label="Clear selection"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                }

                @if (field.searchComponent) {
                    <button
                        mat-icon-button
                        matSuffix
                        class="search-suffix-btn"
                        tabindex="-1"
                        (click)="openSearchDialog(field); $event.stopPropagation()"
                        aria-label="Search"
                    >
                        <mat-icon>search</mat-icon>
                    </button>
                }

                @if (field.required && (isMultiple ? !entity[field.property]?.length : !entity[field.property])) {
                    <mat-error>
                        {{ field.name | translate }} {{ "is required" | translate }}
                    </mat-error>
                }
            </mat-form-field>
        }

        @if (field.type === FormFieldType.Checkbox && field.visible) {
            <div
                [class]="field.cssClass + ' padding-y-10'">
                <mat-checkbox
                    color="primary"
                    [(ngModel)]="entity[field.property]"
                    (change)="field.onChange($event); emitValueChanged()"
                >
                    {{ field.name | translate }}
                </mat-checkbox>
            </div>
        }

        @if (field.type === FormFieldType.Radio && field.visible) {
            <div
                class="padding-y-10"
                [class]="field.cssClass"
            >
                <label class="field-label block mb-2"
                    >{{ field.name | translate }}
                    @if (field.tooltip) {
                        <i
                            class="fa fa-info-circle"
                            aria-hidden="true"
                            [matTooltip]="field.tooltip"
                            matTooltipPosition="right"
                        ></i>
                    }
                </label>
                <mat-radio-group
                    [(ngModel)]="entity[field.property]"
                    (ngModelChange)="field.onChange($event); emitValueChanged()"
                >
                    @for (option of field.options; track $index) {
                        <mat-radio-button
                            [value]="option.id"
                        >
                            {{ option.name | translate }}
                        </mat-radio-button>
                    }
                </mat-radio-group>
            </div>
        }

        @if (field.type === FormFieldType.Label && field.visible) {
            <div
                class="padding-y-10"
                [class]="field.cssClass"
                (click)="field.onClick(entity[field.property])"
            >
                @if (field.iconClass) {
                    <span>
                        <i [ngClass]="field.iconClass" class="icon"></i>
                    </span>
                }
                <mat-label class="mr-3 field-label"
                    >{{ field.name | translate }}
                    @if (field.tooltip) {
                        <i
                            class="fa fa-info-circle"
                            aria-hidden="true"
                            [matTooltip]="field.tooltip"
                            matTooltipPosition="right"
                        ></i>
                    }
                </mat-label>
            </div>
        }

        @if (field.type === FormFieldType.Toggle && field.visible) {
            <div
                class="padding-y-10"
                [class]="field.cssClass"
            >
                <mat-label class="mr-3 field-label"
                    >{{ field.name | translate }}
                    @if (field.tooltip) {
                        <i
                            class="fa fa-info-circle"
                            aria-hidden="true"
                            [matTooltip]="field.tooltip"
                            matTooltipPosition="right"
                        ></i>
                    }
                </mat-label>
                <mat-slide-toggle
                    color="primary"
                    [disabled]="field.readonly"
                    (change)="field.onChange($event, field); emitValueChanged()"
                    [(ngModel)]="entity[field.property]"
                ></mat-slide-toggle>
            </div>
        }

        @if (field.type === FormFieldType.Button && field.visible) {
            <div
                class="padding-y-10"
                [class]="field.cssClass"
            >
                <button
                    mat-button
                    color="primary"
                    (click)="field.onClick(entity[field.property])"
                    class="button date-name"
                    [disabled]="field.readonly"
                >
                    @if (field.iconClass) {
                        <span>
                            <i [ngClass]="field.iconClass" class="icon"></i>
                        </span>
                    }
                    {{ field.name | translate }}
                </button>
            </div>
        }

        @if (field.type === FormFieldType.Number && field.visible) {
            <mat-form-field
                appearance="outline">
                <mat-label class="field-label"
                    >{{ field.name | translate }}
                    {{ field.additionalLabelText }}
                    @if (field.tooltip) {
                        <i
                            class="fa fa-info-circle"
                            aria-hidden="true"
                            [matTooltip]="field.tooltip"
                            matTooltipPosition="right"
                        ></i>
                    }
                </mat-label>
                <input
                    matInput
                    type="number"
                    [required]="field.required"
                    [readonly]="field.readonly"
                    [placeholder]="field.tooltip"
                    [disabled]="field.readonly"
                    (input)="field.onChange($event, field)"
                    [(ngModel)]="entity[field.property]"
                    [min]="field.numericMin"
                    [max]="field.numericMax"
                    (keypress)="
                        onKeyPressValidateInput($event, field.displayFormat)
                    "
                />
                <mat-error
                    >{{ field.name | translate }}
                    {{ "is required" | translate }}</mat-error
                >
            </mat-form-field>
        }

        @if (field.type === FormFieldType.Time && field.visible) {
            <mat-form-field
                appearance="outline">
                <mat-label class="field-label"
                    >{{ field.name | translate }}
                    @if (field.tooltip) {
                        <i
                            class="fa fa-info-circle"
                            aria-hidden="true"
                            [matTooltip]="field.tooltip"
                            matTooltipPosition="right"
                        ></i>
                    }
                </mat-label>
                <input
                    matInput
                    [required]="field.required"
                    [disabled]="field.readonly"
                    class="time-input"
                    [(ngModel)]="entity[field.property]"
                    (ngModelChange)="onTimeChange($event, field)"
                    [ngxMatTimepicker]="timePicker"
                    [format]="'' | hour12Flag"
                    [readonly]="field.readonly"
                    [placeholder]="field.tooltip"
                />
                <ngx-mat-timepicker-toggle
                    matSuffix
                    [for]="timePicker"
                ></ngx-mat-timepicker-toggle>
                <ngx-mat-timepicker
                    #timePicker
                    appendToInput="true"
                ></ngx-mat-timepicker>
                <mat-error
                    >{{ field.name | translate }}
                    {{ "is required" | translate }}</mat-error
                >
            </mat-form-field>
        }

        @if (field.type === FormFieldType.Date && field.visible) {
            <div
                class="date-field"
                [ngClass]="field.cssClass">
                <mat-form-field class="row" appearance="outline">
                    <mat-label class="field-label"
                        >{{ field.name | translate }}
                        @if (field.tooltip) {
                            <i
                                class="fa fa-info-circle"
                                aria-hidden="true"
                                [matTooltip]="field.tooltip"
                                matTooltipPosition="right"
                            ></i>
                        }
                    </mat-label>
                    <input
                        matInput
                        [required]="field.required"
                        [readonly]="field.readonly"
                        [class]="field.cssClass"
                        [(ngModel)]="entity[field.property]"
                        [min]="$safeNavigationMigration(field?.min)"
                        [max]="$safeNavigationMigration(field?.max)"
                        [value]="entity[field.property]"
                        [matDatepicker]="picker"
                        [disabled]="field.readonly"
                        (ngModelChange)="field.onChange($event, field); emitValueChanged()"
                        [placeholder]="field.tooltip"
                    />
                    <mat-datepicker-toggle
                        matIconSuffix
                        [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error
                        >{{ field.name | translate }}
                        {{ "is required" | translate }}</mat-error
                    >
                </mat-form-field>
            </div>
        }

        @if (field.type === FormFieldType.DateTime && field.visible) {
            <div
                class="container"
                [ngClass]="field.cssClass">
                <mat-form-field appearance="outline" class="row">
                    <mat-label class="field-label"
                        >{{ field.name | translate }}
                        @if (field.tooltip) {
                            <i
                                class="fa fa-info-circle"
                                aria-hidden="true"
                                [matTooltip]="field.tooltip"
                                matTooltipPosition="right"
                            ></i>
                        }
                    </mat-label>
                    <input
                        matInput
                        [required]="field.required"
                        [class]="field.cssClass"
                        [(ngModel)]="entity[field.property]"
                        [min]="$safeNavigationMigration(field?.min)"
                        [max]="$safeNavigationMigration(field?.max)"
                        [owlDateTimeTrigger]="dtPicker"
                        [owlDateTime]="dtPicker"
                        [disabled]="field.readonly"
                        (ngModelChange)="field.onChange($event, field); emitValueChanged()"
                        [placeholder]="field.tooltip"
                    />
                    <owl-date-time
                        #dtPicker
                        [panelClass]="'form-owl-date-picker'"
                        [hour12Timer]="('' | hour12Flag) === 12"
                    >
                    </owl-date-time>
                    <mat-error
                        >{{ field.name | translate }}
                        {{ "is required" | translate }}</mat-error
                    >
                </mat-form-field>
            </div>
        }

        @if (field.type === FormFieldType.FileAttachments && field.visible) {
            <div
                class="container"
                [ngClass]="field.cssClass">
                <div class="row">
                    <a class="add-attachment col-md-6" (click)="field.onClick(0)"
                        >{{ field.additionalLabelText }}
                    </a>
                    @for (attachment of field.options; track trackById($index, attachment)) {
                        <div
                            class="attachment-item col-md-6"
                        >
                            <span
                                >{{ attachment.name }}
                                {{ attachment.description }}</span
                            >
                            <button
                                mat-icon-button
                                color="warn"
                                (click)="field.onClick(attachment.id)"
                            >
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
